import * as Yup from 'yup';

export const leadConfigValidationSchema = Yup.object().shape({
    name                                    : Yup.string().required('Source Name is required').max(128),
    numericId                               : Yup.number().required()
    .test(
        'is-less-than-6-digits',
        'Numeric Id must have max 6 digits',
        (value) => {
            if (value === 0) {
              throw new Yup.ValidationError('Numeric Id can\'t be 0', value, 'numericId');
            }

            return value ? value.toString().length <= 6 : false;
          }
    ),
});
